export default "__VITE_ASSET__BAKLwT0s__"